import { useTheme } from '@emotion/react';
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  InputBase,
  Slider,
  Stack,
  useMediaQuery,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import Slide from '@mui/material/Slide';
import Typography from '@mui/material/Typography';
import { getApiCall, postApiCall } from 'api/apiService';
import successgif from 'assets/gifs/successgif.gif';
import retrexlogo from 'assets/icons/retrexlogo.png';
import {
  ChatLoading,
  PropertyWorthChat,
} from 'component/Questionaire/ChatComponent';
import searchIcon from 'assets/svg/searchIcon.svg';
import {
  Bathrooms,
  Bedrooms,
  CancelBtn,
  CancelBtnMobile,
  Floorplan,
  Garden,
  House,
  Location,
  Locationwhite,
  NaturalLightIcon,
  OverAllIcon,
  SelectIcon,
  SuccessBtn,
  SuccessBtnMobile,
  NoneIcon,
  OutdoorSpaceIcon,
  DesignStyleIcon,
  ViewsIcon,
} from 'component/Questionaire/Icons';
import {
  Basename_url,
  BUYER_GETQUESTION,
  BUYER_REVIEW,
  BUYER_SAVEQUESTION,
} from 'constant/app.config';
import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';
import '../../../component/Questionaire/RangeSlider.css';
import { min } from 'moment';
import ScaledDialogContent from 'component/Common/ScaledDialogContent';
import { loginHeadBtn } from 'component/Login/Login.style';
import AgencyBadge from 'component/Common/AgencyBadge';
import LogoutIcon from '@mui/icons-material/Logout';

export const RayWhite = ({ matchessm }) => {
  return (
    <svg
      width={matchessm ? '81' : '141'}
      height={matchessm ? '40' : '60'}
      viewBox="0 0 141 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="141" height="60" fill="#FFE512" />
      <path
        d="M28.44 22.96C29.8933 22.96 31 23.2933 31.76 23.96C32.52 24.6133 32.9 25.4667 32.9 26.52C32.9 26.8267 32.8733 27.1133 32.82 27.38C32.66 28.3133 32.2533 29.1467 31.6 29.88C30.9467 30.6133 30.0733 31.1333 28.98 31.44L31.24 37H27.38L25.4 31.7H24.58L23.64 37H20.22L22.7 22.96H28.44ZM29.32 27.52C29.3467 27.3067 29.36 27.1667 29.36 27.1C29.36 26.6733 29.22 26.3467 28.94 26.12C28.6733 25.88 28.2733 25.76 27.74 25.76H25.62L25 29.28H27.12C27.7467 29.28 28.24 29.1267 28.6 28.82C28.9733 28.5133 29.2133 28.08 29.32 27.52ZM33.5869 31.4C33.7869 30.2533 34.1802 29.2467 34.7669 28.38C35.3535 27.5133 36.0602 26.8467 36.8869 26.38C37.7135 25.9133 38.5869 25.68 39.5069 25.68C40.2935 25.68 40.9535 25.84 41.4869 26.16C42.0202 26.48 42.4069 26.9 42.6469 27.42L42.9269 25.84H46.3469L44.3669 37H40.9469L41.2469 35.42C40.8202 35.94 40.2802 36.36 39.6269 36.68C38.9735 37 38.2535 37.16 37.4669 37.16C36.6802 37.16 35.9802 36.98 35.3669 36.62C34.7669 36.26 34.3002 35.7533 33.9669 35.1C33.6335 34.4333 33.4669 33.6533 33.4669 32.76C33.4669 32.3333 33.5069 31.88 33.5869 31.4ZM41.9469 31.42C41.9869 31.18 42.0069 30.96 42.0069 30.76C42.0069 30.1067 41.8135 29.5933 41.4269 29.22C41.0535 28.8467 40.5735 28.66 39.9869 28.66C39.3069 28.66 38.6869 28.9067 38.1269 29.4C37.5669 29.88 37.2135 30.5467 37.0669 31.4C37.0269 31.64 37.0069 31.86 37.0069 32.06C37.0069 32.7133 37.1935 33.2333 37.5669 33.62C37.9535 33.9933 38.4335 34.18 39.0069 34.18C39.6869 34.18 40.3069 33.9333 40.8669 33.44C41.4269 32.9467 41.7869 32.2733 41.9469 31.42ZM51.3611 25.84L52.7211 32.82L56.5211 25.84H60.2211L50.3211 42.3H46.6411L50.2011 36.62L47.5611 25.84H51.3611ZM81.2778 22.96L75.1378 37H70.9978L70.3778 27.78L66.4378 37H62.2978L61.2178 22.96H64.8778L65.0978 33.18L69.3978 22.96H73.1778L73.7778 33.12L77.5978 22.96H81.2778ZM89.353 25.72C90.4463 25.72 91.3063 26.0333 91.933 26.66C92.573 27.2867 92.893 28.16 92.893 29.28C92.893 29.6533 92.853 30.0533 92.773 30.48L91.613 37H88.213L89.293 30.94C89.333 30.7133 89.353 30.5133 89.353 30.34C89.353 29.78 89.193 29.3467 88.873 29.04C88.5663 28.7333 88.133 28.58 87.573 28.58C86.9063 28.58 86.3463 28.7867 85.893 29.2C85.4396 29.6133 85.1463 30.1933 85.013 30.94V30.9L83.933 37H80.513L83.133 22.2H86.553L85.653 27.32C86.093 26.8267 86.633 26.44 87.273 26.16C87.913 25.8667 88.6063 25.72 89.353 25.72ZM97.8895 24.68C97.3562 24.68 96.9295 24.54 96.6095 24.26C96.3029 23.9667 96.1495 23.6 96.1495 23.16C96.1495 22.56 96.3829 22.0467 96.8495 21.62C97.3162 21.1933 97.8829 20.98 98.5495 20.98C99.0829 20.98 99.5029 21.1267 99.8095 21.42C100.116 21.7 100.27 22.0667 100.27 22.52C100.27 23.1067 100.036 23.6133 99.5695 24.04C99.1029 24.4667 98.5429 24.68 97.8895 24.68ZM99.3695 25.84L97.4095 37H93.9895L95.9495 25.84H99.3695ZM104.528 33.16C104.515 33.2267 104.508 33.3133 104.508 33.42C104.508 33.66 104.575 33.8333 104.708 33.94C104.855 34.0467 105.088 34.1 105.408 34.1H106.628L106.108 37H104.368C102.128 37 101.008 36.06 101.008 34.18C101.008 33.9 101.041 33.5467 101.108 33.12L101.908 28.68H100.548L101.048 25.84H102.408L102.888 23.12H106.308L105.828 25.84H108.068L107.568 28.68H105.328L104.528 33.16ZM114.973 25.68C116.413 25.68 117.553 26.0733 118.393 26.86C119.246 27.6333 119.673 28.6933 119.673 30.04C119.673 30.48 119.64 30.8733 119.573 31.22C119.52 31.5267 119.44 31.8533 119.333 32.2H111.593C111.58 32.28 111.573 32.4067 111.573 32.58C111.573 33.1667 111.733 33.6133 112.053 33.92C112.373 34.2267 112.8 34.38 113.333 34.38C114.186 34.38 114.84 34.02 115.293 33.3H118.933C118.453 34.4333 117.673 35.36 116.593 36.08C115.513 36.8 114.3 37.16 112.953 37.16C111.513 37.16 110.36 36.76 109.493 35.96C108.64 35.16 108.213 34.0733 108.213 32.7C108.213 32.2867 108.253 31.86 108.333 31.42C108.533 30.26 108.946 29.2467 109.573 28.38C110.2 27.5133 110.98 26.8467 111.913 26.38C112.846 25.9133 113.866 25.68 114.973 25.68ZM116.213 30.46C116.24 30.2733 116.253 30.1467 116.253 30.08C116.253 29.5467 116.086 29.14 115.753 28.86C115.42 28.5667 114.98 28.42 114.433 28.42C113.846 28.42 113.326 28.6 112.873 28.96C112.433 29.3067 112.113 29.8067 111.913 30.46H116.213Z"
        fill="#4B4B4B"
      />
    </svg>
  );
};

// Dialog Transition
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

// Function to get initials from agent name
const getInitials = (name) => {
  if (!name) return '';

  return name
    .trim()
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0].toUpperCase())
    .join('');
};

// chat question component
const ChatQuestion = ({
  question,
  quesTrigger1,
  quesTrigger5,
  agentName,
  agentProfileImage,
  agentNameInitial,
}) => {
  const only450screen = useMediaQuery((theme) => theme.breakpoints.down(450));
  const onlysmscreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );
  const onlylgscreen = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const onlyxlscreen = useMediaQuery((theme) => theme.breakpoints.up(1200));
  const only1350screen = useMediaQuery((theme) => theme.breakpoints.up(1350));
  const only1650screen = useMediaQuery((theme) => theme.breakpoints.up(1650));
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));

  return (
    <Stack
      direction={'row'}
      justifyContent={'center'}
      alignItems={'flex-end'}
      gap={'20px'}
      minWidth={matchessm ? '100%' : '500px'}
    >
      <Box
        sx={{
          background: 'rgba(0, 101, 252, 1)',
          width: '100%',
          borderRadius: '50px',
          zIndex: '100',
          paddingX: '10px',
        }}
      >
        <Typography
          component={'p'}
          sx={{
            color: 'white',
            fontSize: { xs: '13px', sm: '15px', md: '20px' },
            fontFamily: 'Poppins',
            fontWeight: '400',
            textAlign: 'left',
            padding:
              only450screen && quesTrigger5
                ? '20px'
                : only450screen && !quesTrigger5
                ? '10px'
                : '20px',
          }}
        >
          {question}
        </Typography>
      </Box>
      <Box
        sx={{
          height: onlySmallScreen ? '40px' : '56px',
          width: onlySmallScreen ? '40px' : '56px',
          background: 'green',
          borderRadius: '50%',
          overflow: 'hidden',

          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',

          color: 'white',
          fontWeight: 600,
          fontFamily: 'Poppins',
          fontSize: onlySmallScreen ? '14px' : '18px',

          flexShrink: 0, // important
        }}
      >
        {agentProfileImage !== '' ? (
          <img
            alt="Profile"
            src={agentProfileImage}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        ) : (
          <Typography
            variant="h6"
            sx={{
              fontFamily: 'Poppins',
              fontSize: { xs: '14px', sm: '16px', md: '18px' },
              color: 'white',
            }}
          >
            {agentNameInitial}
          </Typography>
        )}
      </Box>
    </Stack>
  );
};

//  chat question Options
const ChatOptions = ({
  question,
  setQuestion,
  handleChange,
  search,
  filterData,
  setprevious,
  setcurrent,
  isfirst,
  currentquesno,
  showNoneOption = false, // New prop to control None option visibility
}) => {
  const nextButtonRef = useRef(null);

  useEffect(() => {
    if (question.length > 2 && nextButtonRef.current) {
      nextButtonRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [question.length]);

  const [innerHeight, setInnerHeight] = useState(window.innerHeight);
  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );

  const handleQuestion = (value) => {
    // If selecting "None" (only applicable when showNoneOption is true)
    if (value === 'None') {
      // If None is already selected, deselect it (toggle off)
      if (question.includes('None')) {
        setQuestion([]);
      } else {
        // If None is not selected, select only None (clear others)
        setQuestion(['None']);
      }
      return;
    }

    // For non-None options
    // If "None" is currently selected and user clicks another option, remove None and add the new option
    if (question.includes('None')) {
      setQuestion([value]);
      return;
    }

    // If already selected, remove it (toggle off)
    if (question.includes(value)) {
      const result = question.filter((item) => item !== value);
      setQuestion(result);
    } else {
      // Otherwise, add the new selection (up to 3)
      if (question.length < 3) setQuestion([...question, value]);
    }
  };

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down(500));

  return (
    <Box
      sx={{
        width: { xs: 'auto', sm: '300px', md: '500px' },
        mt: '15px',
      }}
    >
      <Typography
        sx={{
          fontFamily: 'Poppins',
          fontSize: matchessm ? '12px' : '18px',
          fontWeight: '300',
          textAlign: 'center',
          display: 'block',
          p: '20px 0px',
        }}
      >
        Please select up to 3
      </Typography>
      <Grid
        container
        sx={{
          display: 'flex',
          alignItems: 'end',
          justifyContent: 'space-around',
        }}
        md={12}
      >
        <Grid item md={4} sm={4} xs={4} sx={{ textAlign: 'center' }}>
          <IconButton
            disableTouchRipple
            disableFocusRipple
            disableRipple
            onClick={() => {
              handleQuestion('Natural Light');
            }}
            sx={{ position: 'relative' }}
          >
            <Stack
              direction={'column'}
              alignItems={'center'}
              spacing={1}
              justifyContent={'space-between'}
              sx={{
                width: onlySmallScreen ? '75px' : '150px',
                height: !matchessm && '95px',
              }}
            >
              <NaturalLightIcon value={question.includes('Natural Light')} />
              <Typography
                sx={{
                  fontFamily: 'Poppins',
                  fontSize: matchessm ? '12px' : '15px',
                  fontWeight: '300',
                  textAlign: 'center',
                  whiteSpace: 'nowrap',
                }}
              >
                Natural Light
              </Typography>
            </Stack>
            {question.includes('Natural Light') && (
              <Box sx={{ position: 'absolute', top: '0', right: '0' }}>
                <SelectIcon matchessm={matchessm} />
              </Box>
            )}
          </IconButton>
        </Grid>
        <Grid item md={4} sm={4} xs={4} sx={{ textAlign: 'center' }}>
          <IconButton
            disableTouchRipple
            disableFocusRipple
            disableRipple
            onClick={() => {
              handleQuestion('Location');
            }}
            sx={{ position: 'relative' }}
          >
            <Stack
              direction={'column'}
              alignItems={'center'}
              spacing={1}
              justifyContent={'space-between'}
              paddingTop={matchessm ? '10px' : '20px'}
              sx={{
                width: onlySmallScreen ? '75px' : '150px',
                height: !matchessm && '95px',
              }}
            >
              <Location value={question.includes('Location')} />
              <Typography
                sx={{
                  fontFamily: 'Poppins',
                  fontSize: matchessm ? '12px' : '15px',
                  fontWeight: '300',
                  textAlign: 'center',
                }}
              >
                Location
              </Typography>
            </Stack>
            {question.includes('Location') && (
              <Box sx={{ position: 'absolute', top: '0', right: '0' }}>
                <SelectIcon matchessm={matchessm} />
              </Box>
            )}
          </IconButton>
        </Grid>
        <Grid item md={4} sm={4} xs={4} sx={{ textAlign: 'center' }}>
          <IconButton
            disableTouchRipple
            disableFocusRipple
            disableRipple
            onClick={() => {
              handleQuestion('Floorplan/Layout');
            }}
            sx={{ position: 'relative' }}
          >
            <Stack
              direction={'column'}
              alignItems={'center'}
              spacing={1}
              justifyContent={'space-between'}
              paddingTop={'20px'}
              sx={{
                width: onlySmallScreen ? '75px' : '150px',
                height: !matchessm && '95px',
              }}
            >
              <Floorplan value={question.includes('Floorplan/Layout')} />
              <Typography
                sx={{
                  fontFamily: 'Poppins',
                  fontSize: matchessm ? '12px' : '15px',
                  fontWeight: '300',
                  textAlign: 'center',
                }}
              >
                Floorplan/Layout
              </Typography>
            </Stack>
            {question.includes('Floorplan/Layout') && (
              <Box sx={{ position: 'absolute', top: '0', right: '0' }}>
                <SelectIcon matchessm={matchessm} />
              </Box>
            )}
          </IconButton>
        </Grid>
        <Grid item md={4} sm={4} xs={4} sx={{ textAlign: 'center' }}>
          <IconButton
            disableTouchRipple
            disableFocusRipple
            disableRipple
            onClick={() => {
              handleQuestion('Outdoor Space');
            }}
            sx={{ position: 'relative' }}
          >
            <Stack
              direction={'column'}
              alignItems={'center'}
              spacing={1}
              justifyContent={'space-between'}
              paddingTop={'20px'}
              sx={{
                width: onlySmallScreen ? '75px' : '150px',
                height: !matchessm && '95px',
              }}
            >
              <OutdoorSpaceIcon value={question.includes('Outdoor Space')} />
              <Typography
                sx={{
                  fontFamily: 'Poppins',
                  fontSize: matchessm ? '12px' : '15px',
                  fontWeight: '300',
                  textAlign: 'center',
                }}
              >
                Outdoor Space
              </Typography>
            </Stack>
            {question.includes('Outdoor Space') && (
              <Box sx={{ position: 'absolute', top: '0', right: '0' }}>
                <SelectIcon matchessm={matchessm} />
              </Box>
            )}
          </IconButton>
        </Grid>
        <Grid item md={4} sm={4} xs={4} sx={{ textAlign: 'center' }}>
          <IconButton
            disableTouchRipple
            disableFocusRipple
            disableRipple
            onClick={() => {
              handleQuestion('Design/Style');
            }}
            sx={{ position: 'relative' }}
          >
            <Stack
              direction={'column'}
              alignItems={'center'}
              spacing={1}
              justifyContent={'space-between'}
              paddingTop={'20px'}
              sx={{
                width: onlySmallScreen ? '75px' : '150px',
                height: !matchessm && '95px',
              }}
            >
              <DesignStyleIcon value={question.includes('Design/Style')} />
              <Typography
                sx={{
                  fontFamily: 'Poppins',
                  fontSize: matchessm ? '12px' : '15px',
                  fontWeight: '300',
                  textAlign: 'center',
                }}
              >
                Design/Style
              </Typography>
            </Stack>
            {question.includes('Design/Style') && (
              <Box sx={{ position: 'absolute', top: '0', right: '0' }}>
                <SelectIcon matchessm={matchessm} />
              </Box>
            )}
          </IconButton>
        </Grid>
        <Grid item md={4} sm={4} xs={4} sx={{ textAlign: 'center' }}>
          <IconButton
            disableTouchRipple
            disableFocusRipple
            disableRipple
            onClick={() => {
              handleQuestion('Views');
            }}
            sx={{ position: 'relative' }}
          >
            <Stack
              direction={'column'}
              alignItems={'center'}
              spacing={1}
              justifyContent={'space-between'}
              paddingTop={'20px'}
              sx={{
                width: onlySmallScreen ? '75px' : '150px',
                height: !matchessm && '95px',
              }}
            >
              <ViewsIcon value={question.includes('Views')} />
              <Typography
                sx={{
                  fontFamily: 'Poppins',
                  fontSize: matchessm ? '12px' : '15px',
                  fontWeight: '300',
                  textAlign: 'center',
                }}
              >
                Views
              </Typography>
            </Stack>
            {question.includes('Views') && (
              <Box sx={{ position: 'absolute', top: '0', right: '0' }}>
                <SelectIcon matchessm={matchessm} />
              </Box>
            )}
          </IconButton>
        </Grid>

        {/* Only show None option when showNoneOption is true */}
        {showNoneOption && (
          <Grid item md={4} sm={4} xs={4} sx={{ textAlign: 'center', mt: 2 }}>
            <IconButton
              disableTouchRipple
              disableFocusRipple
              disableRipple
              onClick={() => {
                handleQuestion('None');
              }}
              sx={{ position: 'relative' }}
            >
              <Stack
                direction={'column'}
                alignItems={'center'}
                spacing={1}
                justifyContent={'space-between'}
                sx={{
                  width: onlySmallScreen ? '75px' : '150px',
                  height: !matchessm && '95px',
                }}
              >
                <NoneIcon value={question.includes('None')} />
                <Typography
                  sx={{
                    fontFamily: 'Poppins',
                    fontSize: matchessm ? '12px' : '15px',
                    fontWeight: '300',
                    textAlign: 'center',
                  }}
                >
                  None
                </Typography>
              </Stack>
              {question.includes('None') && (
                <Box sx={{ position: 'absolute', top: '0', right: '0' }}>
                  <SelectIcon matchessm={matchessm} />
                </Box>
              )}
            </IconButton>
          </Grid>
        )}
      </Grid>

      {search && filterData.length > 0 && (
        <>
          <Typography
            sx={{
              fontFamily: 'Poppins',
              fontSize: matchessm ? '12px' : '18px',
              fontWeight: '600',
              textAlign: 'left',
              display: 'block',
            }}
          >
            More
          </Typography>

          <Grid
            container
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
            md={12}
          >
            {filterData
              .filter((item) => item.name !== 'None')
              .map((item) => (
                <Grid
                  item
                  md={4}
                  sm={4}
                  xs={4}
                  key={item.id}
                  sx={{ textAlign: 'center' }}
                >
                  <IconButton
                    disableTouchRipple
                    disableFocusRipple
                    disableRipple
                    onClick={() => handleQuestion(item.name)}
                    sx={{ position: 'relative' }}
                  >
                    <Stack
                      direction="column"
                      alignItems="center"
                      justifyContent="space-between"
                      sx={{
                        width: onlySmallScreen ? '75px' : '150px',
                        height: !matchessm && '95px',
                      }}
                    >
                      <item.icon value={question.includes(item.name)} />
                      <Typography
                        sx={{
                          fontFamily: 'Poppins',
                          fontSize: matchessm ? '12px' : '15px',
                          fontWeight: '300',
                          textAlign: 'center',
                        }}
                      >
                        {item.name}
                      </Typography>
                    </Stack>
                    {question.includes(item.name) && (
                      <Box sx={{ position: 'absolute', top: '0', right: '0' }}>
                        <SelectIcon />
                      </Box>
                    )}
                  </IconButton>
                </Grid>
              ))}
          </Grid>
        </>
      )}
      <Box
        sx={{
          paddingX: matchessm ? '10%' : '20%',
          isplay: 'flex',
          right: '0%',
          position: 'absolute',
          bottom: '20%',
          justifyContent: matchessm ? 'right' : null,
        }}
      >
        {isfirst != currentquesno && (
          <IconButton
            sx={{ fontSize: '16px', marginRight: '5px' }}
            onClick={() => {
              setcurrent(false);
              setprevious(true);
            }}
          >
            Back
          </IconButton>
        )}
        <Button
          variant="contained"
          disableElevation
          disableFocusRipple
          disableRipple
          disableTouchRipple
          disabled={question.length <= 0}
          sx={{
            color: 'white',
            background: 'rgba(76, 164, 214, 1) !important',
            borderRadius: '20px',
            width: { xs: 80, sm: 144, md: 144 },
            textTransform: 'capitalize',
            alignSelf: 'flex-end',
            fontWeight: 'bold',
          }}
          color="primary"
          onClick={handleChange}
        >
          Next
        </Button>
      </Box>
    </Box>
  );
};

const RatingBtn = ({ color, value, setQuestion1, handleChange }) => {
  const only450Screen = useMediaQuery((theme) => theme.breakpoints.down(450));
  const onlyxsScreen = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  const onlysmScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );
  const onlylgScreen = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const onlyxlScreen = useMediaQuery((theme) => theme.breakpoints.down('xl'));
  return (
    <Button
      sx={{
        minWidth: only450Screen
          ? '32px'
          : onlyxsScreen
          ? '25px'
          : onlysmScreen
          ? '40px'
          : onlySmallScreen
          ? '50px'
          : onlylgScreen
          ? '70px'
          : onlyxlScreen
          ? '90px'
          : '90px',
        height: only450Screen
          ? '32px'
          : onlyxsScreen
          ? '25px'
          : onlysmScreen
          ? '35px'
          : onlySmallScreen
          ? '40px'
          : onlylgScreen
          ? '50px'
          : onlyxlScreen
          ? '60px'
          : '60px',
        fontFamily: 'Poppins',
        fontSize: onlyxsScreen
          ? '10px'
          : onlysmScreen
          ? '10px'
          : onlySmallScreen
          ? '12px'
          : onlylgScreen
          ? '14px'
          : onlyxlScreen
          ? '16px'
          : '16px',
        background: `${color} !important`,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'white',
        borderLeft: '1px solid lightGray',
        cursor: 'pointer',
        borderRadius:
          value == 1 ? '10px 0px 0px 10px' : value == 10 ? '0 10px 10px 0' : 0,
      }}
      onClick={() => {
        setQuestion1(value);
        handleChange();
      }}
    >
      {value}
    </Button>
  );
};

const showIcons = [
  { id: 1, name: 'House', icon: House },
  { id: 3, name: 'Bathrooms', icon: Bathrooms },
  { id: 4, name: 'None', icon: NoneIcon },
];

export default function BuyerChat() {
  const history = useHistory();

  const only450Screen = useMediaQuery((theme) => theme.breakpoints.down(450));
  const onlyxsScreen = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  const onlysmScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const onlySmallScreen = useMediaQuery((theme) =>
    theme.breakpoints.down('md')
  );
  const onlylgScreen = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const onlyxlScreen = useMediaQuery((theme) => theme.breakpoints.down('xl'));

  const [search, setSearch] = useState('');

  const filterData = showIcons.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase())
  );

  // chat questions
  const [chatQuestion, setChatQuestion] = useState([]);

  // chat property Details
  const [propertyLocation, setPropertyLocation] = useState(
    '56 Owen Street, North Bondi'
  );
  const [agentName, setAgentName] = useState('');
  const [agencyName, setAgencyName] = useState('');
  const [agentProfileImage, setAgentProfileImage] = useState('');
  const [agentNameInitial, setAgentNameInitial] = useState('');
  const [propertyID, setPropertyID] = useState(null);
  const [priceRange, setPriceRange] = useState({ min: 0, max: 6000000 });
  const [minSliderValue, setMinSliderValue] = useState(0);
  const [maxSliderValue, setMaxSliderValue] = useState(0);

  // chat question values
  const [question1, setQuestion1] = useState('');
  const [question2, setQuestion2] = useState('');
  const [question3, setQuestion3] = useState([]);
  const [question4, setQuestion4] = useState([]);
  const [question5, setQuestion5] = useState(2000000);

  // trigger next chat Question
  const [quesTrigger1, setQuesTrigger1] = useState(false);
  const [quesTrigger2, setQuesTrigger2] = useState(false);
  const [quesTrigger3, setQuesTrigger3] = useState(false);
  const [quesTrigger4, setQuesTrigger4] = useState(false);
  const [quesTrigger5, setQuesTrigger5] = useState(false);

  // final thanks Screen trigger
  const [finalTrigger, setfinalTrigger] = useState(false);

  // chat loading
  const [loading, setLoading] = React.useState(false);

  // chat Dialog State
  const [buyerChatDialog, setbuyerChatDialog] = useState(false);

  const [currentQuestionId, setCurrentQuestionId] = useState(null);
  const [isfirst, setIsfirst] = useState('');

  // chat dialog Close function
  const handleClose = () => {
    setbuyerChatDialog(false);
    window.open(`${Basename_url}` + '/dashboard', '_self');
  };

  useEffect(() => {
    setQuestion1('');
    setQuestion2('');
    setQuestion3([]);
    setQuestion4([]);
    setQuestion5([2000000]);
  }, [finalTrigger]);

  // api to get chat questions
  const GetQuestions = () => {
    getApiCall(BUYER_REVIEW).then((res) => {
      if (res?.data?.status == 1) {
        if (res?.data?.propertyList?.length > 0) {
          setPropertyLocation(res?.data?.propertyList[0]?.propertyAddress);
          setAgentName(res?.data?.propertyList[0]?.agentName);
          setAgencyName(res?.data?.propertyList[0]?.agentAgencyName);
          setAgentProfileImage(res?.data?.propertyList[0]?.agentProfileImage);
          setAgentNameInitial(res?.data?.propertyList[0]?.agentNameIntial);
          setPropertyID(res?.data?.propertyList[0]?.propertyId);
          const fetchedPriceRange = res?.data?.propertyList[0]?.priceRange;
          if (fetchedPriceRange) {
            const [minPrice, maxPrice] = fetchedPriceRange
              .split('-')
              .map(Number);
            setPriceRange({ min: minPrice, max: maxPrice });
            const deviation = 80;
            const minSlider = Math.round(minPrice * ((100 - deviation) / 100));
            const maxSlider = Math.round(maxPrice * ((100 + deviation) / 100));

            setMinSliderValue(minSlider);
            setMaxSliderValue(maxSlider);
            setRange((maxSlider + minSlider) / 2);
            setQuestion5((maxSlider + minSlider) / 2);
          }
          getApiCall(
            `${BUYER_GETQUESTION}/${res?.data?.propertyList[0]?.propertyId}`
          ).then((res) => {
            if (res?.data?.status == 1) {
              if (res?.data?.buyerQuestions[0].questionAnswer == '') {
                if (isfirst == '') {
                  setIsfirst(1);
                }
                setfinalTrigger(false);
                setQuesTrigger1(true);
                setbuyerChatDialog(true);
              } else if (res?.data?.buyerQuestions[1].questionAnswer == '') {
                if (isfirst == '') {
                  setIsfirst(2);
                }
                setfinalTrigger(false);
                setQuesTrigger2(true);
                setbuyerChatDialog(true);
              } else if (res?.data?.buyerQuestions[2].questionAnswer == '') {
                if (isfirst == '') {
                  setIsfirst(3);
                }
                setfinalTrigger(false);
                setQuesTrigger3(true);
                setbuyerChatDialog(true);
              } else if (res?.data?.buyerQuestions[3].questionAnswer == '') {
                if (isfirst == '') {
                  setIsfirst(4);
                }
                setfinalTrigger(false);
                setQuesTrigger4(true);
                setbuyerChatDialog(true);
              } else if (res?.data?.buyerQuestions[4].questionAnswer == '') {
                if (isfirst == '') {
                  setIsfirst(5);
                }
                setfinalTrigger(false);
                setQuesTrigger5(true);
                setbuyerChatDialog(true);
              } else {
                setIsfirst(1);
                setfinalTrigger(false);
                setQuesTrigger2(true);
                setbuyerChatDialog(true);
              }
              setChatQuestion([...res?.data?.buyerQuestions]);
            }
          });
        } else {
          handleClose();
        }
      }
    });
  };

  // api to post chat questions
  const PostQuestion = (questionId) => {
    const questions = [
      {
        questionId: 1,
        questionCode: 'BQ001',
        questionAnswer: question1,
        propertyId: propertyID,
        questionIsSkiped: 0,
        questionValue: chatQuestion[0]?.questionValue,
      },
      {
        questionId: 2,
        questionCode: 'BQ002',
        questionAnswer: question2,
        propertyId: propertyID,
        questionIsSkiped: 0,
        questionValue: chatQuestion[1]?.questionValue,
      },
      {
        questionId: 3,
        questionCode: 'BQ003',
        questionAnswer: question3,
        propertyId: propertyID,
        questionIsSkiped: 0,
        questionValue: chatQuestion[2]?.questionValue,
      },
      {
        questionId: 4,
        questionCode: 'BQ004',
        questionAnswer: question4,
        propertyId: propertyID,
        questionIsSkiped: 0,
        questionValue: chatQuestion[3]?.questionValue,
      },
      {
        questionId: 5,
        questionCode: 'BQ005',
        questionAnswer: question5,
        propertyId: propertyID,
        questionIsSkiped: 0,
        questionValue: chatQuestion[4]?.questionValue,
      },
    ];
    return questions.find((q) => q.questionId === questionId);
  };

  useEffect(() => {
    if (currentQuestionId !== null) {
      const question = PostQuestion(currentQuestionId);
      if (!question) return;
      if (currentQuestionId != 5) {
        setLoading(true);
      }
      const data = {
        buyerQuestionData: [question],
      };

      postApiCall(BUYER_SAVEQUESTION, data)
        .then(() => {
          if (currentQuestionId === 5) {
            setfinalTrigger(true);
            setTimeout(() => {
              setIsfirst('');
              GetQuestions();
            }, 2000);
          }
        })
        .catch((error) => {
          console.error(
            `Error submitting Question ${currentQuestionId}:`,
            error
          );
        })
        .finally(() => {
          setTimeout(() => {
            setLoading(false);
            setCurrentQuestionId(null);
          }, 2000);
        });
    }
  }, [currentQuestionId, minSliderValue, maxSliderValue]);

  // trigger next question with loading trigger
  const handleChange = ({ trigger1, trigger2, questionId }) => {
    trigger1(false);
    if (questionId != 5) {
      setLoading(true);
    }
    setCurrentQuestionId(questionId);
    setTimeout(() => {
      setLoading(false);
      trigger2(true);
    }, 2000);
  };

  useEffect(() => {
    GetQuestions();
  }, []);
  const [range, setRange] = useState([2000000]);

  function valueLabelFormat(slidervalue) {
    const units = '$';
    return (
      <Typography
        sx={{ fontFamily: 'Poppins', fontWeight: '600' }}
      >{`${units}${slidervalue}`}</Typography>
    );
  }

  const theme = useTheme();
  const only500screen = useMediaQuery((theme) => theme.breakpoints.down(500));
  const [innerHeight, setInnerHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setInnerHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <React.Fragment>
      <Dialog
        fullScreen
        open={buyerChatDialog}
        PaperProps={{
          sx: {
            width: '100vw',
            height: '100vh',
            maxWidth: '100vw',
            maxHeight: '100vh',
            borderRadius: 0,
          },
        }}
      >
        <ScaledDialogContent>
          <DialogTitle
            sx={{
              display: 'grid',
              gridTemplateColumns: 'minmax(0, 1fr) auto',
              alignItems: 'center',
              columnGap: '8px',
              width: '100%',
              boxSizing: 'border-box',
              padding: matchessm ? '10px' : '16px 24px',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '5px',
                minWidth: 0,
                width: '100%',
              }}
            >
              <Box
                sx={{
                  flexShrink: 0,
                  display: 'flex',
                }}
              >
                <Locationwhite />
              </Box>

              <Typography
                sx={{
                  color: 'rgba(30, 30, 30, 1)',
                  fontFamily: 'Poppins',
                  fontWeight: '600',

                  fontSize: {
                    xs: '16px',
                    sm: '18px',
                    md: '18px',
                    lg: '26px',
                    xl: '30px',
                  },

                  minWidth: 0,
                  whiteSpace: 'normal',
                  overflowWrap: 'break-word',
                  wordBreak: 'break-word',
                }}
              >
                {propertyLocation}
              </Typography>
            </Box>

            <Box
              sx={{
                flexShrink: 0,
              }}
            >
              {matchessm ? (
                <IconButton
                  onClick={() => {
                    history.push('/logout');
                  }}
                  sx={{
                    padding: '4px',
                  }}
                >
                  <LogoutIcon fontSize="medium" />
                </IconButton>
              ) : (
                <Button
                  style={{ borderRadius: '0px' }}
                  sx={loginHeadBtn}
                  onClick={() => {
                    history.push('/logout');
                  }}
                >
                  LOGOUT
                </Button>
              )}
            </Box>
          </DialogTitle>
          {agencyName && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                mt: matchessm ? '0px' : '20px',
              }}
            >
              <AgencyBadge name={agencyName} variant="survey" />
            </Box>
          )}

          <DialogContent
            sx={{
              mt: matchessm ? '5px' : '50px',
              padding: '5px',
              overflow: 'visible',
            }}
          >
            <Stack
              direction={'column'}
              justifyContent={'center'}
              alignItems={'center'}
              gap={matchessm ? '0px' : '25px'}
            >
              {quesTrigger1 && (
                <>
                  <ChatQuestion
                    question={chatQuestion[0]?.questionValue}
                    quesTrigger1={quesTrigger1}
                    agentName={agentName}
                    agentProfileImage={agentProfileImage}
                    agentNameInitial={agentNameInitial}
                  />

                  <Box>
                    <Stack
                      direction={'row'}
                      justifyContent={'center'}
                      alignItems={'center'}
                      mt={'25px'}
                    >
                      <RatingBtn
                        value={1}
                        color={'#ed544f'}
                        setQuestion1={setQuestion1}
                        handleChange={() =>
                          handleChange({
                            trigger1: setQuesTrigger1,
                            trigger2: setQuesTrigger2,
                            questionId: chatQuestion[0]?.questionId,
                          })
                        }
                      />
                      <RatingBtn
                        value={2}
                        color={'#ed544f'}
                        setQuestion1={setQuestion1}
                        handleChange={() =>
                          handleChange({
                            trigger1: setQuesTrigger1,
                            trigger2: setQuesTrigger2,
                            questionId: chatQuestion[0]?.questionId,
                          })
                        }
                      />
                      <RatingBtn
                        value={3}
                        color={'#ee534f'}
                        setQuestion1={setQuestion1}
                        handleChange={() =>
                          handleChange({
                            trigger1: setQuesTrigger1,
                            trigger2: setQuesTrigger2,
                            questionId: chatQuestion[0]?.questionId,
                          })
                        }
                      />
                      <RatingBtn
                        value={4}
                        color={'#ee534f'}
                        setQuestion1={setQuestion1}
                        handleChange={() =>
                          handleChange({
                            trigger1: setQuesTrigger1,
                            trigger2: setQuesTrigger2,
                            questionId: chatQuestion[0]?.questionId,
                          })
                        }
                      />
                      <RatingBtn
                        value={5}
                        color={'#ee534f'}
                        setQuestion1={setQuestion1}
                        handleChange={() =>
                          handleChange({
                            trigger1: setQuesTrigger1,
                            trigger2: setQuesTrigger2,
                            questionId: chatQuestion[0]?.questionId,
                          })
                        }
                      />
                      <RatingBtn
                        value={6}
                        color={'#ee534f'}
                        setQuestion1={setQuestion1}
                        handleChange={() =>
                          handleChange({
                            trigger1: setQuesTrigger1,
                            trigger2: setQuesTrigger2,
                            questionId: chatQuestion[0]?.questionId,
                          })
                        }
                      />
                      <RatingBtn
                        value={7}
                        color={'#ffa824'}
                        setQuestion1={setQuestion1}
                        handleChange={() =>
                          handleChange({
                            trigger1: setQuesTrigger1,
                            trigger2: setQuesTrigger2,
                            questionId: chatQuestion[0]?.questionId,
                          })
                        }
                      />
                      <RatingBtn
                        value={8}
                        color={'#ffa824'}
                        setQuestion1={setQuestion1}
                        handleChange={() =>
                          handleChange({
                            trigger1: setQuesTrigger1,
                            trigger2: setQuesTrigger2,
                            questionId: chatQuestion[0]?.questionId,
                          })
                        }
                      />
                      <RatingBtn
                        value={9}
                        color={'#7eb442'}
                        setQuestion1={setQuestion1}
                        handleChange={() =>
                          handleChange({
                            trigger1: setQuesTrigger1,
                            trigger2: setQuesTrigger2,
                            questionId: chatQuestion[0]?.questionId,
                          })
                        }
                      />
                      <RatingBtn
                        value={10}
                        color={'#7eb442'}
                        setQuestion1={setQuestion1}
                        handleChange={() =>
                          handleChange({
                            trigger1: setQuesTrigger1,
                            trigger2: setQuesTrigger2,
                            questionId: chatQuestion[0]?.questionId,
                          })
                        }
                      />
                    </Stack>
                    <Stack
                      direction={'row'}
                      justifyContent={'center'}
                      alignItems={'center'}
                      mt={'25px'}
                    >
                      <Box
                        sx={{
                          fontFamily: 'Poppins',
                          fontSize: only450Screen
                            ? '10px'
                            : onlysmScreen
                            ? '12px'
                            : onlySmallScreen
                            ? '14px'
                            : onlylgScreen
                            ? '14px'
                            : onlyxlScreen
                            ? '16px'
                            : '16px',
                          width: only450Screen
                            ? '80px'
                            : onlysmScreen
                            ? '90px'
                            : onlySmallScreen
                            ? '100px'
                            : onlylgScreen
                            ? '180px'
                            : onlyxlScreen
                            ? '180px'
                            : '180px',
                          height: '60px',
                          background: '#ed544f',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          color: 'white',
                          textAlign: 'center',
                          borderRight: '1px solid lightGray',
                          borderRadius: '10px 0 0 10px',
                        }}
                      >
                        Extremely dissatisfied
                      </Box>
                      <Box
                        sx={{
                          fontFamily: 'Poppins',
                          fontSize: only450Screen
                            ? '10px'
                            : onlysmScreen
                            ? '12px'
                            : onlySmallScreen
                            ? '14px'
                            : onlylgScreen
                            ? '14px'
                            : onlyxlScreen
                            ? '16px'
                            : '16px',
                          width: only450Screen
                            ? '70px'
                            : onlysmScreen
                            ? '90px'
                            : onlySmallScreen
                            ? '100px'
                            : onlylgScreen
                            ? '120px'
                            : onlyxlScreen
                            ? '180px'
                            : '180px',
                          height: '60px',
                          background: '#ed544f',
                          textAlign: 'center',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          color: 'white',
                          borderRight: '1px solid lightGray',
                        }}
                      >
                        Dissatisfied
                      </Box>
                      <Box
                        sx={{
                          fontFamily: 'Poppins',
                          fontSize: only450Screen
                            ? '10px'
                            : onlysmScreen
                            ? '12px'
                            : onlySmallScreen
                            ? '14px'
                            : onlylgScreen
                            ? '14px'
                            : onlyxlScreen
                            ? '16px'
                            : '16px',
                          width: only450Screen
                            ? '50px'
                            : onlysmScreen
                            ? '70px'
                            : onlySmallScreen
                            ? '100px'
                            : onlylgScreen
                            ? '120px'
                            : onlyxlScreen
                            ? '180px'
                            : '180px',
                          height: '60px',
                          background: '#ed544f',
                          display: 'flex',
                          textAlign: 'center',
                          justifyContent: 'center',
                          alignItems: 'center',
                          color: 'white',
                          borderRight: '1px solid lightGray',
                        }}
                      >
                        Neither
                      </Box>
                      <Box
                        sx={{
                          fontFamily: 'Poppins',
                          fontSize: only450Screen
                            ? '10px'
                            : onlysmScreen
                            ? '12px'
                            : onlySmallScreen
                            ? '14px'
                            : onlylgScreen
                            ? '14px'
                            : onlyxlScreen
                            ? '16px'
                            : '16px',
                          width: only450Screen
                            ? '60px'
                            : onlysmScreen
                            ? '70px'
                            : onlySmallScreen
                            ? '100px'
                            : onlylgScreen
                            ? '120px'
                            : onlyxlScreen
                            ? '180px'
                            : '180px',
                          height: '60px',
                          background: '#ffa824',
                          display: 'flex',
                          textAlign: 'center',
                          justifyContent: 'center',
                          alignItems: 'center',
                          color: 'white',
                          borderRight: '1px solid lightGray',
                        }}
                      >
                        Satisfied
                      </Box>
                      <Box
                        sx={{
                          fontFamily: 'Poppins',
                          fontSize: only450Screen
                            ? '10px'
                            : onlysmScreen
                            ? '12px'
                            : onlySmallScreen
                            ? '14px'
                            : onlylgScreen
                            ? '14px'
                            : onlyxlScreen
                            ? '16px'
                            : '16px',
                          width: only450Screen
                            ? '60px'
                            : onlysmScreen
                            ? '80px'
                            : onlySmallScreen
                            ? '100px'
                            : onlylgScreen
                            ? '160px'
                            : onlyxlScreen
                            ? '180px'
                            : '180px',
                          height: '60px',
                          background: '#7eb442',
                          display: 'flex',
                          textAlign: 'center',
                          justifyContent: 'center',
                          alignItems: 'center',
                          color: 'white',
                          borderRadius: '0 10px 10px 0',
                        }}
                      >
                        Extremely satisfied
                      </Box>
                    </Stack>
                  </Box>
                </>
              )}
              {quesTrigger2 && (
                <>
                  <ChatQuestion
                    question={chatQuestion[1]?.questionValue}
                    agentName={agentName}
                    agentProfileImage={agentProfileImage}
                    agentNameInitial={agentNameInitial}
                  />
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      mt: '6%',
                      flexDirection: 'row',
                      width: matchessm ? '80%' : '30%',
                    }}
                  >
                    <IconButton
                      disableTouchRipple
                      disableFocusRipple
                      disableRipple
                      onClick={() => {
                        setQuestion2('Yes');
                        handleChange({
                          trigger1: setQuesTrigger2,
                          trigger2: setQuesTrigger3,
                          questionId: chatQuestion[1]?.questionId,
                        });
                      }}
                    >
                      {onlySmallScreen ? <SuccessBtnMobile /> : <SuccessBtn />}
                    </IconButton>
                    <IconButton
                      disableTouchRipple
                      disableFocusRipple
                      disableRipple
                      onClick={() => {
                        setQuestion2('No');
                        handleChange({
                          trigger1: setQuesTrigger2,
                          trigger2: setQuesTrigger3,
                          questionId: chatQuestion[1]?.questionId,
                        });
                      }}
                    >
                      {onlySmallScreen ? <CancelBtnMobile /> : <CancelBtn />}
                    </IconButton>
                    <Box
                      sx={{
                        display: 'flex',
                        width: matchessm ? '80%' : '30%',
                        position: 'absolute',
                        flexDirection: 'row',
                        bottom: '20%',
                        justifyContent: 'right',
                      }}
                    >
                      {isfirst != 2 && (
                        <IconButton
                          sx={{ fontSize: '16px' }}
                          onClick={() => {
                            setQuesTrigger2(false);
                            setQuesTrigger1(true);
                          }}
                        >
                          Back
                        </IconButton>
                      )}
                    </Box>
                  </Box>
                </>
              )}
              {quesTrigger3 && (
                <>
                  <ChatQuestion
                    question={chatQuestion[2]?.questionValue}
                    matchessm={matchessm}
                    agentName={agentName}
                    agentProfileImage={agentProfileImage}
                    agentNameInitial={agentNameInitial}
                  />

                  <ChatOptions
                    question={question3}
                    setQuestion={setQuestion3}
                    search={search}
                    setprevious={setQuesTrigger2}
                    setcurrent={setQuesTrigger3}
                    filterData={filterData}
                    handleChange={() =>
                      handleChange({
                        trigger1: setQuesTrigger3,
                        trigger2: setQuesTrigger4,
                        questionId: chatQuestion[2]?.questionId,
                      })
                    }
                    isfirst={isfirst}
                    currentquesno={3}
                    showNoneOption={false} // No None option for "What did you like"
                  />
                </>
              )}
              {quesTrigger4 && (
                <>
                  <ChatQuestion
                    question={chatQuestion[3]?.questionValue}
                    agentName={agentName}
                    agentProfileImage={agentProfileImage}
                    agentNameInitial={agentNameInitial}
                  />

                  <ChatOptions
                    question={question4}
                    setQuestion={setQuestion4}
                    setprevious={setQuesTrigger3}
                    setcurrent={setQuesTrigger4}
                    search={search}
                    filterData={filterData}
                    handleChange={() =>
                      handleChange({
                        trigger1: setQuesTrigger4,
                        trigger2: setQuesTrigger5,
                        questionId: chatQuestion[3]?.questionId,
                      })
                    }
                    isfirst={isfirst}
                    currentquesno={4}
                    showNoneOption={true} // Show None option for "What didn't you like"
                  />
                </>
              )}
              {quesTrigger5 && (
                <>
                  <ChatQuestion
                    question={chatQuestion[4]?.questionValue.replace(
                      /X/g,
                      'at ' + propertyLocation
                    )}
                    quesTrigger5={quesTrigger5}
                    agentName={agentName}
                    agentProfileImage={agentProfileImage}
                    agentNameInitial={agentNameInitial}
                  />

                  <Box
                    sx={{
                      width: onlySmallScreen ? '80%' : '40%',
                      mt: '30px',
                    }}
                  >
                    <PropertyWorthChat
                      value={`${minSliderValue}-${maxSliderValue}`}
                      handleInputChange={(val) => {
                        setRange(val);
                        setQuestion5(val);
                      }}
                    />

                    <Box
                      sx={{
                        paddingX: matchessm ? '10%' : '20%',
                        display: 'flex',
                        right: '0%',
                        position: 'absolute',
                        bottom: '20%',
                        justifyContent: matchessm ? 'right' : null,
                      }}
                    >
                      {isfirst != 5 && (
                        <IconButton
                          sx={{ fontSize: '16px', marginRight: '5px' }}
                          onClick={() => {
                            setQuesTrigger5(false);
                            setQuesTrigger4(true);
                          }}
                        >
                          Back
                        </IconButton>
                      )}
                      <Button
                        variant="contained"
                        disableElevation
                        disableFocusRipple
                        disableRipple
                        disableTouchRipple
                        sx={{
                          color: 'white',
                          background: 'rgba(76, 164, 214, 1) !important',
                          borderRadius: '20px',
                          width: { xs: 80, sm: 144, md: 144 },
                          textTransform: 'capitalize',
                          fontWeight: 'bold',
                        }}
                        color="primary"
                        onClick={() =>
                          handleChange({
                            trigger1: setQuesTrigger5,
                            trigger2: setfinalTrigger,
                            questionId: chatQuestion[4]?.questionId,
                          })
                        }
                      >
                        Submit
                      </Button>
                    </Box>
                  </Box>
                </>
              )}

              {finalTrigger && (
                <>
                  <Box>
                    <Typography
                      style={{
                        color: 'rgb(154, 188, 102)',
                        textAlign: 'center',
                        fontFamily: 'poppins',
                        fontSize: matchessm ? '16px' : '24px',
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      You're one step closer to find your dream property !
                    </Typography>
                  </Box>

                  <img
                    src={successgif}
                    alt="successgif"
                    style={{
                      width: matchessm ? '100%' : '700px',
                    }}
                  />
                </>
              )}
              {loading && (
                <ChatLoading
                  value={agentNameInitial}
                  agentProfileImage={agentProfileImage}
                />
              )}
            </Stack>
          </DialogContent>
          <DialogActions
            sx={{
              position: 'absolute',
              right: '24px',
              bottom: '24px',
              margin: 0,
              padding: 0,
            }}
          >
            <Box sx={{ padding: '20px' }}>
              <Typography
                component={'div'}
                sx={{
                  fontFamily: 'Poppins',
                  fontWeight: '300',
                  fontSize: '12px',
                }}
              >
                Powered by
              </Typography>
              <img
                style={{
                  display: 'block',
                  objectFit: 'contain',
                  width: matchessm ? '80px' : '120px',
                }}
                alt="logo"
                src={retrexlogo}
              />
            </Box>
          </DialogActions>
        </ScaledDialogContent>
      </Dialog>
    </React.Fragment>
  );
}
